import { useAutoneTranslation } from '@autone/translations';
import { Badge } from '@autone/ui';
import { useFormContext } from 'react-hook-form';

import { type APP_NAME } from '../../../../consts';
import { useGetProductsCount } from '../../../../hooks';
import { type DownloadAssortmentTemplateFormSchema } from '../DownloadTemplateModal.schema';

export const CoreProductsCountBadge = () => {
  const { common } = useAutoneTranslation<typeof APP_NAME>();
  const { control } = useFormContext<DownloadAssortmentTemplateFormSchema>();
  const { count, isFetching } = useGetProductsCount(control);

  if (isFetching) {
    return <Badge variant={'loading'} />;
  } else if (count === 0) {
    return (
      <Badge variant={'error'}>
        {common('scope-count-badge.products', { count })}
      </Badge>
    );
  } else {
    return (
      <Badge variant={'success'}>
        {common('scope-count-badge.products', { count })}
      </Badge>
    );
  }
};
